<template>
	<div>
		<h3>The available services we found</h3>
		<div>
			<ul>
				<template v-for="payout in list_payout">
					<li :class="{active : pickReceiving ==payout}" @click="changePayout(payout)">{{ labelPayout(payout) }}</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{

			}
		},
		props:['list_payout','pickReceiving'],

		methods : {
			changePayout(value){
				this.$emit('changePayout', value);
			},
      labelPayout(value){
        if(value == 'Bank transfer'){
          return 'Transfer to a bank account'; 
        } else if(value == 'Cash pickup'){
          return 'Transfer to a cash pick-up location'; 
        } else if(value == 'Cash home delivery'){
          return 'By cash home delivery'; 
        } else if(value == 'Mobile wallet'){
          return 'Via mobile wallet'; 
        } else if(value == 'Cash home delivery'){
          return 'By cash home delivery'; 
        } else if(value == 'Airtime top-up'){
          return 'Adding credit to a pre-paid phone'; 
        } else {
          return value;
        }
      }
		}
	}
</script>

<style lang="scss" scoped>

  
  h3 {
    width: 85%;
    margin-left: auto;
    margin-right: auto;
  }
  
  ul {
  	margin: 0;
    padding: 0;
    padding-bottom: 20px;
    list-style: none;
  }

  li {
  	text-align: center;
    padding: 14px 20px;
    color: #51575E;
    font-style: 14px;
    position: relative;	
    font-family: 'Avenir Next';
    font-weight: 500;
    text-align: center;
    display: block;
    cursor: pointer;

  	&.active{
  	  border: none;
 	    background-color: #0cc3ca;
      color: #fff;
      left: -22px;
      padding: 16px 20px;
      width : calc(100% + 12px);
      position: relative;
      font-weight: 600;
      cursor: default;
      border-radius: 0px 8px 8px 0px;
      box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.1);
      -webkit-box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.1);
      -moz-box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.1);

      &:after {
        content: '';
      	width: 0;
      	height: 0;
      	border-top: 27px solid transparent;
      	border-bottom: 27px solid transparent;
      	border-right: 16px solid #0cc3ca;
      	left: -16px;
      	top: 0;
      	position: absolute;
	   }  
    }

    
  }
</style>



// WEBPACK FOOTER //
// src/components/PickPayout.vue